import {isEmpty} from "lodash";

const allPopupStatus = {};

export function setPopupOpen(id, data = {}) {
  if (!data.open) {
    data = Object.assign(data, {open: true});
  }

  allPopupStatus[id] = data;
  console.log(`OPEN; popup status: ${JSON.stringify(allPopupStatus, null, 2)}`);

  return allPopupStatus;
}

export function setPopupClosed(id) {
  delete allPopupStatus[id];
  console.log(`CLOSE; popup status: ${JSON.stringify(allPopupStatus, null, 2)}`);
}

export function getPopupStatus(id) {
  return allPopupStatus[id];
}

export function getAllPopupStatus() {
  return allPopupStatus;
}

export function anyPopupIsOpen() {
  return !isEmpty(allPopupStatus);
}
